import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export const removeVoucher = (pathParams: { voucherAction: string }) =>
    axios.delete(`${API_URLS.CART}${pathParams.voucherAction}`);
